<template>
  <div>
    <contact-custom-fields></contact-custom-fields>
    <contact-types></contact-types>
    <contact-tags></contact-tags>
  </div>
</template>

<script>
import ContactCustomFields from "./components/ContactCustomFields";
import ContactTags from "./components/ContactTags";
import ContactTypes from "./components/ContactTypes";

export default {
  name: "ContactsTab",
  components: {
    ContactTypes,
    ContactTags,
    ContactCustomFields
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
